import { useTenantContext } from '@/contexts/TenantContext';

// Hook simplificado para usar apenas o tenant
export function useTenant() {
  const { tenant, isLoading, error, refreshTenant } = useTenantContext();
  return { tenant, isLoading, error, refreshTenant };
}

// Hook para usar o tenant com funções de atualização
export function useTenantWithActions() {
  const { tenant, setTenant, isLoading, error, refreshTenant } = useTenantContext();
  return { tenant, setTenant, isLoading, error, refreshTenant };
}

// Hook para verificar se o tenant está ativo
export function useTenantStatus() {
  const { tenant, isLoading } = useTenantContext();
  return {
    isActive: tenant?.is_active ?? false,
    isLoading,
    hasTenant: !!tenant
  };
}

// Hook para usar configurações específicas do tenant
export function useTenantConfig() {
  const { tenant, isLoading } = useTenantContext();
  
  return {
    // Configurações visuais
    colors: {
      primary: tenant?.configurations?.cor_primaria || '#b3956c',
      secondary: tenant?.configurations?.cor_secundaria || '#6b7280',
      highlight: tenant?.configurations?.cor_destaque || '#f59e0b',
      background: tenant?.configurations?.cor_fundo || '#ffffff',
      text: tenant?.configurations?.cor_texto || '#1f2937'
    },
    
    // Configurações de negócio
    business: {
      currency: 'BRL',
      locale: 'pt-BR',
      timezone: 'America/Sao_Paulo',
      cnpj: tenant?.cnpj,
      phone: tenant?.telefone,
      supportEmail: tenant?.configurations?.support_email, // ✅ Corrigido para usar configurations
      whatsapp: undefined
    },
    
    // Configurações de domínio
    domain: {
      main: tenant?.domain,
      subdomain: tenant?.subdomain,
      slug: tenant?.slug
    },
    
    // Funcionalidades
    features: [], // Removido: features não existe mais no novo schema
    settings: {}, // Removido: settings não existe mais no novo schema
    
    // Status
    isActive: tenant?.is_active ?? false,
    subscriptionPlan: tenant?.subscription_plan,
    subscriptionStatus: tenant?.subscription_status,
    trialEndsAt: tenant?.trial_ends_at,
    
    isLoading
  };
}
